var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.623,
    height: 12.623,
    viewBox: "0 0 12.623 12.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-info-circle",
    d: "M6.874.563a6.312,6.312,0,1,0,6.312,6.312A6.313,6.313,0,0,0,6.874.563Zm0,2.8A1.069,1.069,0,1,1,5.805,4.431,1.069,1.069,0,0,1,6.874,3.362ZM8.3,9.826a.305.305,0,0,1-.305.305H5.754a.305.305,0,0,1-.305-.305V9.215a.305.305,0,0,1,.305-.305H6.06V7.281H5.754a.305.305,0,0,1-.305-.305V6.365a.305.305,0,0,1,.305-.305H7.383a.305.305,0,0,1,.305.305V8.91h.305a.305.305,0,0,1,.305.305Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#0b1741"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoCircle);
export default __webpack_public_path__ + "static/media/icon-info-circle.ce1f1c818f3ef9ebd8f64bfc28a9b344.svg";
export { ForwardRef as ReactComponent };